export const DEFAULT = 'default' // Note: Not actually a real mode, used by embed code generator when not specifying a particular mode
export const TIMELINE = 'timeline'
export const LIST = 'list'
export default {
  DEFAULT,
  LIST,
  TIMELINE,
}
